module.exports = __webpack_public_path__ + "assets/static/png/zsu-logo.084c9ee71a4f682255bff1b142e091c1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/receipt/images/zsu-logo.png
 ** module id = 527
 ** module chunks = 1
 **/